import React, { useState, useEffect } from "react";
import "./notification.css";
import $ from "jquery";
import useHttp from "../../../hooks/useHttp.js";
import APIService from "../../../services/apiAxiosService.js";

const Notification = (props) => {
  const [noData, setNoData] = useState(1);
  const [notificationData, setnotificationData] = useState([]);
  const { sendRequest: roleNotificationAPI } = useHttp();

  const notifcationResponse = (allNotifications) => {
    if (allNotifications.MSG !== undefined) {
      if (allNotifications.MSG.length > 0) {
        setnotificationData(allNotifications.MSG);
        setNoData(0);
      } else {
        setNoData(1);
        $("#not_avl").show();
      }
      $("#preloader").hide();
    }
  };

  const getNotifications = async () => {
    await roleNotificationAPI(
      APIService.getNotifcationsByRoleID(),
      notifcationResponse
    );
  };

  function formatDate(date) {
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const handleComponent = (data) => {
    if (sessionStorage.getItem("roleId") == 3) {
      if (
        data === "created New Third Party Request" ||
        data === "approved Assessment Plan" ||
        data === "update risk request"
      ) {
        props.history.push("/analyst");
      } else if (
        data === "Issue updated successfully" ||
        data === "update the issue" ||
        data === "Issue updated successfully" ||
        data === "Issue request for approval"
      ) {
        props.history.push("/analystIssues");
      }
    } else if (sessionStorage.getItem("roleId") == 2) {
      if (data === "review risk request") {
        props.history.push("/manager/risk_management");
      } else {
        props.history.push("/manager");
      }
    } else if (sessionStorage.getItem("roleId") == 1) {
      if (data === "created risk successfully") {
        props.history.push("/risk");
      } else {
        props.history.push("/thirdpartyRequestManagement");
      }
    } else if (sessionStorage.getItem("roleId") == 4) {
      if (data === "update risk request") {
        props.history.push("/riskManagement");
      } else if (
        data === "Initiated on-site assessment" ||
        data === "Conducted on-site assessment"
      ) {
        props.history.push("/onsiteAssessment");
      } else {
        props.history.push("/initiateAssessment");
      }
    } else if (sessionStorage.getItem("roleId") == 6) {
      if (data === "created work program") {
        props.history.push("/masterRepository");
      } else {
        props.history.push("/users");
      }
    } else {
      if (data === "Initiated self assessment") {
        props.history.push("/vendor");
      } else {
        props.history.push("/vendor/issue_management");
      }
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);

  return (
    <div className="container-fluid pr-22">
      <div className="dashboard-card p-4">
        <div className="row">
          <div className="col-12 font-20 color-46 mt-5 fw-500">
            Notifications
          </div>
        </div>
        <div className="row" id="preloader">
          <div className="col-12 col-md-12 col-lg-12 mt-3 text-center">
            <div className="a-loading a-primary a-m-10">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
        {noData === 0 ? (
          <div className="row">
            {notificationData &&
              notificationData.map((item, index) => {
                return (
                  <div
                    className="col-12 col-sm-12 col-md-6 col-lg-4 pt-3 pl-2 pr-2"
                    key={index + 1}
                  >
                    <div className="notification-card p-3">
                      <div className="row"></div>
                      <div className="row pt-2">
                        <div
                          className="col-12 color-46 font-13 font-weight-bold pointer"
                          onClick={() => handleComponent(item.emailcontent)}
                        >
                          {item.emailcontent + " By " + item.username}
                        </div>
                      </div>
                      <div className="row pt-2">
                        <div className="col-12 color-7d font-13 font-weight-bold">
                          {item.msgtype}
                        </div>
                      </div>
                      <div className="row pt-4">
                        <div className="col-6 color-7d font-11 font-weight-bold">
                          {formatDate(item.createddate)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        ) : (
          <div className="row" id="not_avl" style={{ display: "none" }}>
            <div className="col-12 text-center">No Data available</div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Notification;
